"use client";

import React, { useState, useRef, useEffect } from "react";
import Image from "next/image";

const VimeoPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const wrapperRef = useRef(null);

  const videoUrl =
    "https://player.vimeo.com/video/964249802?h=27b8234ada&color=F2AA3C&title=0&byline=0&portrait=0&dnt=1&transparent=1&autoplay=1";

  const handleThumbnailClick = () => {
    setIsPlaying(true);
  };

  // As soon as isPlaying flips, request fullscreen on our wrapper
  // useEffect(() => {
  //   if (isPlaying && wrapperRef.current) {
  //     const el = wrapperRef.current;
  //     if (el.requestFullscreen) {
  //       el.requestFullscreen().catch(() => {});
  //     } else if ((el).webkitRequestFullscreen) {
  //       (el).webkitRequestFullscreen();
  //     } else if ((el).mozRequestFullScreen) {
  //       (el).mozRequestFullScreen();
  //     } else if ((el).msRequestFullscreen) {
  //       (el).msRequestFullscreen();
  //     }
  //   }
  // }, [isPlaying]);

  return (
    <div
      ref={wrapperRef}
      onClick={!isPlaying ? handleThumbnailClick : undefined}
      className="
    relative
    w-full       
    md:w-1/3     
    mx-auto     
    overflow-hidden
    rounded-2xl
    cursor-pointer
    group
    ml-2
    mr-2
  "
    >
      <div className="relative w-full aspect-video">
        {!isPlaying ? (
          <>
            <Image
              src="/images/vimeo_thumbnail_with_play.webp"
              alt="Vimeo Thumbnail"
              fill
              className="rounded-2xl block group-hover:hidden transition-opacity duration-300 object-cover"
            />
            <Image
              src="/images/vimeo_thumbnail_with_play_hover.webp"
              alt="Vimeo Thumbnail Hover"
              fill
              className="rounded-2xl hidden group-hover:block transition-opacity duration-300 object-cover"
            />
          </>
        ) : (
          <iframe
            src={videoUrl}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            className="absolute top-0 left-0 w-full h-full rounded-2xl"
          />
        )}
      </div>
    </div>

  );
};

export default VimeoPlayer;
